export enum QueueStatus {
  IN_QUEUE = { code: 'IN_QUEUE', description: 'QUEUE.STATUS_IN_QUEUE', color: 'primary' } as any,
  NOTIFIED = { code: 'NOTIFIED', description: 'QUEUE.STATUS_NOTIFIED', color: 'red' } as any,
  CONFIRMED = { code: 'CONFIRMED', description: 'QUEUE.STATUS_CONFIRMED', color: 'green' } as any,
  NO_SHOW = { code: 'NO_SHOW', description: 'QUEUE.STATUS_NO_SHOW', color: 'dark' } as any,
  CANCELED_BY_STORE = {
    code: 'CANCELED_BY_STORE',
    description: 'QUEUE.STATUS_CANCELED_BY_STORE',
    color: 'dark',
  } as any,
  CANCELED_BY_CUSTOMER = {
    code: 'CANCELED_BY_CUSTOMER',
    description: 'QUEUE.STATUS_CANCELED_BY_CUSTOMER',
    color: 'dark',
  } as any,
  UNDEFINED = { code: 'UNDEFINED', description: 'QUEUE.UNDEFINED', color: 'dark' } as any,
}



// WEBPACK FOOTER //
// ./src/app/pages/queue/enums/queue-status.enum.ts